interface IOptions {
  verbose: boolean;
}

class Logger {
  private verbose = false;

  setOptions({ verbose }: IOptions) {
    this.verbose = verbose;
  }

  log(...args: any[]) {
    if (window.console && this.verbose) {
      window.console.log(...args);
    }
  }
}
const logger = new Logger();
export { logger };
